<template>
  <b-modal
    id="get-help-modal"
    ref="modal"
    class="modal"
  >
    <template #modal-header>
      <crisis-header :college-has-crisis-phone-feature="collegeHasCrisisPhoneFeature()" />
      <button class="close" @click="hide()">
        ×
      </button>
    </template>

    <crisis-blurb
      :college-has-crisis-phone-feature="collegeHasCrisisPhoneFeature()"
      :college="college()"
    />
    <template
      slot="modal-footer"
      slot-scope="{ ok, cancel }"
    >
      <button
        class="btn btn-wide"
        type="button"
        @click="hide()"
      >
        {{ okText }}
      </button>
    </template>
  </b-modal>
</template>

<script>

import CrisisBlurb from './crisis-blurb.vue'
import CrisisHeader from './crisis-header.vue';

export default {
  name: 'GetHelpModal',
  components: {
    CrisisBlurb,
    CrisisHeader,
  },
  props: {
    okText: {
      type: String,
      require: false,
      default: 'I Understand'
    }
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    college() {
      return this.$store.getters.currentUser.school;
    },
    collegeHasCrisisPhoneFeature() {
      return !!this.college().bettermynd_crisis_phone;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
